/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Modal } from '../../shared/modals/Modal';
import { Pressable, StyleSheet, useWindowDimensions, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors } from '../../shared/theme/ticketColors';
import { CatalogMastersScreen } from '../screens/masters/CatalogMastersScreen';
import { TicketModalHeader } from '../../shared/ticket/TicketModalHeader';

type MastersSectionId = 'categories' | 'brands' | 'suppliers';

type Props = {
  visible: boolean;
  onClose: () => void;
  /** Sección inicial al abrir el hub (p. ej. desde Marcas). */
  initialSection?: MastersSectionId;
};

/** Hub de maestros como overlay (no navega a otra pantalla del shell). */
export function CatalogMastersModal({
  visible,
  onClose,
  initialSection = 'categories',
}: Props) {
  const insets = useSafeAreaInsets();
  const { width, height } = useWindowDimensions();
  const wide = width >= 768;

  if (!visible) return null;

  const mastersBody = (
    <CatalogMastersScreen
      key={initialSection}
      embedded
      hideTitle
      initialSection={initialSection}
    />
  );

  if (!wide) {
    return (
      <Modal visible transparent animationType="slide" onRequestClose={onClose}>
        <View style={[styles.mobileRoot, { paddingTop: insets.top }]}>
          <View style={styles.sheetGrabber} />
          <TicketModalHeader
            kicker="Catálogo"
            title="Organizar"
            subtitle="Categorías, marcas y proveedores"
            onClose={onClose}
            compact
          />
          <View style={styles.mobileBody}>{mastersBody}</View>
        </View>
      </Modal>
    );
  }

  return (
    <Modal visible transparent animationType="fade" onRequestClose={onClose}>
      <View style={styles.deskBackdrop}>
        <Pressable style={StyleSheet.absoluteFill} onPress={onClose} />
        <View
          style={[
            styles.deskCard,
            {
              maxWidth: Math.min(1360, width - 48),
              height: Math.min(792, height - 48),
              maxHeight: Math.min(792, height - 48),
              paddingBottom: Math.max(insets.bottom, spacing.sm),
            },
          ]}
        >
          <TicketModalHeader
            kicker="Catálogo"
            title="Organizar"
            subtitle="Categorías, marcas y proveedores"
            onClose={onClose}
          />
          <View style={styles.deskBody}>{mastersBody}</View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  mobileRoot: {
    flex: 1,
    backgroundColor: ticketColors.paper,
  },
  sheetGrabber: {
    width: 42,
    height: 4,
    borderRadius: 999,
    backgroundColor: ticketColors.ruleSoft,
    alignSelf: 'center',
    marginTop: spacing.sm,
  },
  mobileBody: {
    flex: 1,
    minHeight: 0,
  },
  deskBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  deskCard: {
    width: '100%',
    backgroundColor: ticketColors.paper,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    zIndex: 1,
  },
  deskBody: {
    flex: 1,
    minHeight: 0,
  },
});
